var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarClient(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9761 3C9.94258 3 8.96218 3.43885 8.24737 4.20212C7.70481 4.78146 7.34764 5.51209 7.20776 6.29398H2.75014C2.33593 6.29398 2.00014 6.62977 2.00014 7.04398V10.8731C1.99995 10.8829 1.99995 10.8927 2.00014 10.9025V19.1219C2.00014 19.5361 2.33593 19.8719 2.75014 19.8719H19.2027C19.6169 19.8719 19.9527 19.5361 19.9527 19.1219V10.9024C19.9529 10.8927 19.9529 10.8829 19.9527 10.8731V7.04398C19.9527 6.62977 19.6169 6.29398 19.2027 6.29398H14.7445C14.6046 5.51209 14.2474 4.78146 13.7049 4.20212C12.9901 3.43885 12.0096 3 10.9761 3ZM13.2071 6.29398C13.0929 5.89148 12.8881 5.52437 12.61 5.22745C12.1678 4.75523 11.5789 4.5 10.9761 4.5C10.3733 4.5 9.78446 4.75523 9.34222 5.22745C9.06415 5.52437 8.85935 5.89148 8.74517 6.29398H13.2071ZM18.4527 7.79398V10.2722L10.9764 11.7691L3.50014 10.2722V7.79398H18.4527ZM3.50014 18.3719V11.802L10.8292 13.2694C10.9264 13.2888 11.0265 13.2888 11.1236 13.2694L18.4527 11.802V18.3719H3.50014Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClient);
export default __webpack_public_path__ + "static/media/sidebar-client.395d1c83.svg";
export { ForwardRef as ReactComponent };